import { render } from "./CourseComment.vue?vue&type=template&id=13bd75bb"
import script from "./CourseComment.vue?vue&type=script&lang=js"
export * from "./CourseComment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__